import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { TableLoader } from "../../../Common/ShimmerLoader";
import MUITable from "../../../Common/MUITable";
import isGHMC from "../../../Common/helper/helpar";
import { ExportSlaCategory } from "./ExportSlaCategory";
import AddEditSlaCategoryForm from "./AddEditSlaCategoryForm";
import { StatusBadge } from "../../Rfid/utils/statusBadge";
import {
  formatTimeTo12Hour,
  useSlaCategoryStore,
} from "./SlaCategorystore/useSlaCategoryStore";

const SlaCategoryRootComponent = () => {
  const isProd = isGHMC();
  const [showModal, setShowModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const {
    filteredSlaCategories,
    isLoading,
    filters,
    pagination,
    fetchSlaCategories,
    searchSlaCategoryHandler,
  } = useSlaCategoryStore();

  useEffect(() => {
    fetchSlaCategories();
  }, [fetchSlaCategories]);

  const handleSearchChange = (event) => {
    searchSlaCategoryHandler(event.target.value);
  };

  const handlePageChange = (_event, newPage) => {
    fetchSlaCategories({
      currentPage: newPage + 1,
    });
  };

  const handleRowsPerPageChange = (event) => {
    const nextPageSize = parseInt(event.target.value, 10);
    fetchSlaCategories({
      currentPage: 1,
      pageSize: nextPageSize,
    });
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    setEditRow(row);
    setShowModal(true);
  };

  const handleAdd = () => {
    setIsEditMode(false);
    setEditRow(null);
    setShowModal(true);
  };

  const slaCategoryColumns = [
    {
      label: "Category Name",
      field: "categoryName",
    },
    {
      label: "Duration (In Hr)",
      field: "durationInHr",
    },
    {
      label: "Start Time",
      render: (row) => formatTimeTo12Hour(row.startTime),
    },
    {
      label: "End Time",
      render: (row) => formatTimeTo12Hour(row.endTime),
    },
    {
      label: "Status",
      render: (row) => <StatusBadge isActive={row.isActive} compact />,
    },
    {
      label: "Actions",
      render: (row) => (
        <button
          type="button"
          className={isProd ? "edit-ghmc" : "edit-swm"}
          onClick={() => handleEdit(row)}
          aria-label={`Edit ${row.categoryName}`}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="content text-start">
        <div className="page-content">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
            <div>
              <h5 className="mb-1 fw-semibold">SLA Category Information</h5>
              <p className="text-muted mb-0">
                Manage SLA durations for complaint categories.
              </p>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <button type="button" className="button-container" onClick={handleAdd}>
                <FaPlus className="font-size-20 me-1" /> Add SLA Category
              </button>
              <ExportSlaCategory slaCategoryData={filteredSlaCategories} />
            </div>
          </div>

          <div className="card shadow mt-3">
            <div className="card-body">
              <div className="row align-items-end justify-content-start">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      type="text"
                      name="searchTerm"
                      value={filters.searchTerm}
                      onChange={handleSearchChange}
                      placeholder="Search Category Name"
                      className="form-control bg-white"
                    />
                  </div>
                </div>
              </div>

              <div>
                <div className="top-header text-center">
                  <span>SLA Category List</span>
                </div>
                <MUITable loading={isLoading}
                  needSRNumber
                  rows={filteredSlaCategories}
                  columns={slaCategoryColumns}
                  serverPagination
                  totalCount={pagination.totalCount}
                  page={Math.max(0, pagination.currentPage - 1)}
                  rowsPerPage={pagination.pageSize}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                  rowsPerPageOptions={[10, 100, 1000, 10000]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEditSlaCategoryForm
        showModal={showModal}
        setShowModal={setShowModal}
        editRow={editRow}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default SlaCategoryRootComponent;
